import React from 'react';
import { t } from '@lingui/macro';

import { CarouselLeftSmall, CarouselRightSmall } from '@rover/icons';
import { Flex } from '@rover/kibble/core';
import Button from '@rover/kibble/core/Button';

export enum PaginateDirection {
  NEXT = 1,
  PREVIOUS = -1,
}

type Props = React.ComponentProps<typeof Flex> & {
  currentPage: number;
  totalPages: number;
  canPaginateNext: boolean;
  canPaginatePrevious: boolean;
  handlePageChange: (direction: PaginateDirection) => void;
};

const Stepper: React.FC<Props> = ({
  handlePageChange,
  currentPage,
  totalPages,
  canPaginateNext,
  canPaginatePrevious,
  ...flexProps
}) => {
  return (
    <Flex
      minWidth="15x"
      gap="5x"
      flex="none"
      alignItems="center"
      justifyContent={['center', 'right']}
      {...flexProps}
    >
      <Button
        data-qa-id="paginate-previous"
        icon={CarouselLeftSmall}
        disabled={!canPaginatePrevious}
        circular
        aria-label={t`paginate previous`}
        onClick={() => handlePageChange(PaginateDirection.PREVIOUS)}
      />
      {`${currentPage} / ${totalPages}`}
      <Button
        data-qa-id="paginate-next"
        icon={CarouselRightSmall}
        disabled={!canPaginateNext}
        circular
        aria-label={t`paginate next`}
        onClick={() => handlePageChange(PaginateDirection.NEXT)}
      />
    </Flex>
  );
};

export default Stepper;
